import { Capacitor } from "@capacitor/core"
import { AppThunk } from "../appStore"
import { backgroundSyncMwTick } from "../backgroundSyncMw"

interface appStateChangeArgs {
	isActive: boolean
}

export const appStateChange = ({isActive}: appStateChangeArgs): AppThunk<void> => async (dispatch, getState) => {
	if(!Capacitor.isNativePlatform()) {
		return
	}
	if(isActive) {
		// kick off a background refresh whenever the app is foregrounded on iOS
		dispatch(backgroundSyncMwTick({reschedule: false}))
		return
	}
	// the app is backgrounding: iOS may suspend us, and we can't block that.
	// best-effort push any pending device-to-cloud items now so a clinician
	// leaving the app doesn't strand captured data on the device.
	if(getState().dashboardData.pendingDeviceToCloudCount > 0) {
		dispatch(backgroundSyncMwTick({reschedule: false}))
	}
}
